import { UIHeading1 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './NewbuildingBrokerGalleryBanner.css';

interface INewbuildingBrokerGalleryBannerProps {
  isFullscreen: boolean;
  imageType: 'service-logo' | 'key';
  title: string;
  buttons: React.ReactNode;
}

export const NewbuildingBrokerGalleryBanner = ({
  isFullscreen,
  imageType,
  title,
  buttons,
}: React.PropsWithChildren<INewbuildingBrokerGalleryBannerProps>) => {
  return (
    <div
      className={cx(styles['container'], { [styles['container--fullscreen']]: isFullscreen })}
      data-testid="NewbuildingBrokerGalleryBanner"
    >
      <div className={cx(styles['image'], styles[imageType])} />
      <div className={styles['main']}>
        <UIHeading1 textAlign="center">{title}</UIHeading1>
        <div className={styles['buttons']}>{buttons}</div>
      </div>
    </div>
  );
};
